import { getCookie } from '@gto/helpers/cookies'
import { createI18n } from 'vue-i18n'

import en from '@/locales/en'
import de from '@/locales/translated/de.json'
import es from '@/locales/translated/es.json'
import fr from '@/locales/translated/fr.json'
import hu from '@/locales/translated/hu.json'
import it from '@/locales/translated/it_IT.json'
import ja from '@/locales/translated/ja.json'
import ko from '@/locales/translated/ko.json'
import nl from '@/locales/translated/nl.json'
import pl from '@/locales/translated/pl.json'
import pt from '@/locales/translated/pt.json'
import ro from '@/locales/translated/ro.json'
import ru from '@/locales/translated/ru.json'
import sl from '@/locales/translated/sl.json'
import th from '@/locales/translated/th.json'
import zh from '@/locales/translated/zh_CN.json'
import uk from '@/locales/translated/uk.json'
import hr from '@/locales/translated/hr.json'

// TODO lazyload langs https://kazupon.github.io/vue-i18n/guide/lazy-loading.html

// For export to Lokalize
// console.log(JSON.stringify(en))
// https://www.notion.so/gtowizard/How-to-db182e1cf1904492ac79b5299b7a26de

const allMessages = {
  en,
  zh,
  fr,
  it,
  pt,
  ro,
  ru,
  es,
  th,
  pl,
  hu,
  ko,
  sl,
  de,
  ja,
  nl,
  uk,
  hr,
}

const langList = [
  'en',
  'zh',
  'pt',
  'es',
  'ru',
  'fr',
  'it',
  'th',
  'ro',
  'pl',
  'hu',
  'ko',
  'de',

  'ja',
  // 'sl',
  'nl',
  'uk',
  'hr',
]

const messages = {}

langList.forEach(i => {
  messages[i] = allMessages[i]
})

let sysLang = navigator.language || 'en-US'
sysLang = sysLang.split('-')[0]

let selectedLang: string | null = getCookie('GTO_LANGUAGE')

if (!selectedLang) {
  selectedLang = localStorage.getItem('lang') // dev and legacy fallback
}

if (langList.some(i => i === selectedLang)) {
  sysLang = selectedLang || 'en'
}
if (!langList.some(i => i === sysLang)) {
  sysLang = 'en'
}

const g1 = getCookie('GTO_G1') === 'enabled'
if (g1) {
  sysLang = 'en'
}

const i18n: any = createI18n({
  fallbackLocale: 'en',
  // when we get rid of old stuff vue2 way we can safely turn this off
  legacy: true,
  locale: sysLang,
  messages,
  warnHtmlInMessage: 'off',
})

i18n.global.g1 = !!g1

if (import.meta.env.VITE_ENV === 'production' ? import.meta.env.VITE_BRANCH !== 'master' : true) {
  i18n.global.g1 = localStorage.getItem('G1_no_poker_word') === 'magic-enabled'
  sysLang = 'en'
}

// dev only
// i18n.global.g1 = true

const t = i18n.global.t
const tc = i18n.global.tc

const te = (translationKey, fallback) => {
  const translation = t(translationKey) // when i18n does not find a match it returns the key
  return translation === translationKey ? fallback : translation
}

const tce = (options, fallback = '') => {
  const translation = tc(...options)
  return translation === options[0] ? fallback : translation
}

export {
  i18n, //
  g1,
  t,
  te,
  tc,
  langList,
  tce,
}
